module.exports = __webpack_public_path__ + "static/media/news-5.022f28db.jpg";